import { FC, useEffect, useRef, useState } from 'react';
import { Modal } from '@mui/material';
import axios from 'axios';
import "../../index.css"
import { useLandingStyles, PRELOADER_FALLBACK_STYLE } from './landingStyles';
import SigninForm from './SigninForm';

import BgImg from './images/header/banner-bg.svg';
import BgImg2 from './images/bg2.png';
import Img0 from './images/icon.png';
import Img1 from './images/wareozo-light.png';
import Img01 from './images/wareozo.png';
import SignUpForm from '../SignUp/SignUpForm';
import ForgotPassword from '../ForgotPassword/ForgotPassword';

const OptInForm: FC = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const [type, setType] = useState('0');
  const [submitted, setSubmitted] = useState(false);

  const navRef = useRef<any>();
  const [width, setWidth] = useState<number>(window.innerWidth);

  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    countryCode: '+91',
    email: '',
    businessName: '',
    whatsapp: false,
    email_channel: false,
    sms: false,
    transactional: false,
    promotional: false,
    updates: false,
    agreePrivacy: false,
  });

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  // Landing chrome (bootstrap + marketing theme + Muli form theme) is global
  // CSS; keep it alive only while this page is mounted.
  const stylesReady = useLandingStyles();

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const { offsetTop } = navRef.current;
      if (window.pageYOffset > offsetTop) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const isMobile = width <= 768;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1200);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const target = e.target as HTMLInputElement;
    const { name, value, type } = target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? target.checked : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.fullName || !formData.phone) {
      alert('Please fill in your full name and phone number.');
      return;
    }

    if (!formData.whatsapp && !formData.email_channel && !formData.sms) {
      alert('Please select at least one communication channel.');
      return;
    }

    if (!formData.transactional && !formData.promotional && !formData.updates) {
      alert('Please select at least one message category.');
      return;
    }

    if (!formData.agreePrivacy) {
      alert('Please agree to the Privacy Policy to continue.');
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}api/v1/consent/opt-in`, {
        fullName: formData.fullName,
        phone: formData.phone,
        countryCode: formData.countryCode,
        email: formData.email,
        businessName: formData.businessName,
        channels: {
          whatsapp: formData.whatsapp,
          email: formData.email_channel,
          sms: formData.sms,
        },
        categories: {
          transactional: formData.transactional,
          promotional: formData.promotional,
          updates: formData.updates,
        },
      });
      setSubmitted(true);
    } catch (err: any) {
      const message = err?.response?.data?.message || 'Something went wrong. Please try again.';
      alert(message);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    marginBottom: '6px',
    fontWeight: 600,
    fontSize: '14px',
    color: '#374151',
  };

  const checkboxLabelStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    color: '#374151',
    cursor: 'pointer',
  };

  return (
    <>
      {(loading || !stylesReady) && <div className="preloader" style={PRELOADER_FALLBACK_STYLE}>
        <div className="loader">
          <div className="spinner">
            <div className="spinner-container">
              <div className="spinner-rotator">
                <div className="spinner-left">
                  <div className="spinner-circle"></div>
                </div>
                <div className="spinner-right">
                  <div className="spinner-circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}

      <header className="header-area" style={{marginTop: '-64px'}}>
        <div ref={navRef} className={`navbar-area ${scrolled && 'sticky'}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav className="navbar navbar-expand-lg">
                  <a className="navbar-brand" href="/signin">
                    <img src={Img0} alt="Logo" style={{ width: isMobile ? scrolled ? 40 : 60 : scrolled ? 50 : 80 }} />
                    <img src={scrolled ? Img01 : Img1} alt="Logo" style={{ width: isMobile ? scrolled ? 80 : 120 : scrolled ? 120 : 150 }} />
                  </a>
                  <button
                    className={`navbar-toggler ${menu && 'active'}`}
                    type="button"
                    onClick={() => setMenu(!menu)}
                  >
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                  </button>

                  <div className={`collapse navbar-collapse sub-menu-bar ${menu && 'show'}`}>
                    <ul id="nav" className="navbar-nav ms-auto">
                      <li className="nav-item" onClick={() => setMenu(false)}>
                        <a className="page-scroll" href="/signin#home">Home</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(false)}>
                        <a className="page-scroll" href="/signin#features">Features</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(false)}>
                        <a className="page-scroll" href="/signin#pricing">Pricing</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(false)}>
                        <a className="page-scroll" href="/signin#about">About</a>
                      </li>
                    </ul>
                  </div>

                  <div className="navbar-btn d-none d-sm-inline-block">
                    <a
                      className="main-btn"
                      style={{ backgroundColor: scrolled ? '#059669' : '#fff', color: scrolled ? '#fff' : '#059669', border: '2px solid #059669', textDecoration: 'none' }}
                      onClick={() => setOpen(!open)}
                      rel="nofollow"
                    >
                      Login Now
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div
          id="home"
          className="header-hero bg_cover"
          style={{ backgroundImage: `url(${BgImg})` }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="header-hero-content text-center">
                  <h2
                    className="header-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.5s"
                  >
                    Communication Opt-In
                  </h2>
                </div>
              </div>
            </div>
            <div style={{ height: 300 }}></div>
          </div>
          <div id="particles-1" className="particles"></div>
        </div>
      </header>

      <section>
        <div style={{padding: '0 10%'}}>
          <div style={{ maxWidth: '700px', margin: '40px auto' }}>
            {submitted ? (
              <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>&#10003;</div>
                <h3 style={{ color: '#059669', marginBottom: '12px' }}>Consent Recorded Successfully</h3>
                <p style={{ color: '#6b7280', fontSize: '15px' }}>
                  Thank you for subscribing. Your communication preferences have been saved.
                  You can update or withdraw your consent at any time by visiting our <a href="/opt-out" style={{ color: '#059669' }}>Opt-Out page</a>.
                </p>
              </div>
            ) : (
              <>
                <p style={{ color: '#6b7280', fontSize: '15px', marginBottom: '30px' }}>
                  By completing this form, you provide your explicit consent to receive communications from Wareozo
                  through your selected channels. You can withdraw your consent at any time via our <a href="/opt-out" style={{ color: '#059669' }}>Opt-Out page</a>.
                </p>

                <form onSubmit={handleSubmit}>
                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '20px', marginBottom: '24px' }}>
                    <div>
                      <label style={labelStyle}>Full Name <span style={{color: 'red'}}>*</span></label>
                      <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} style={inputStyle} placeholder="Enter your full name" />
                    </div>
                    <div>
                      <label style={labelStyle}>Business Name</label>
                      <input type="text" name="businessName" value={formData.businessName} onChange={handleChange} style={inputStyle} placeholder="Enter business name" />
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '120px 1fr', gap: '10px', marginBottom: '20px' }}>
                    <div>
                      <label style={labelStyle}>Code</label>
                      <select name="countryCode" value={formData.countryCode} onChange={handleChange} style={{...inputStyle, cursor: 'pointer'}}>
                        <option value="+91">+91 (IN)</option>
                        <option value="+1">+1 (US)</option>
                        <option value="+44">+44 (UK)</option>
                        <option value="+971">+971 (UAE)</option>
                        <option value="+61">+61 (AU)</option>
                        <option value="+65">+65 (SG)</option>
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Phone Number <span style={{color: 'red'}}>*</span></label>
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} style={inputStyle} placeholder="Enter phone number" />
                    </div>
                  </div>

                  <div style={{ marginBottom: '24px' }}>
                    <label style={labelStyle}>Email Address</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} placeholder="Enter email address" />
                  </div>

                  <div style={{ marginBottom: '24px', padding: '20px', backgroundColor: '#f9fafb', borderRadius: '10px', border: '1px solid #e5e7eb' }}>
                    <label style={{...labelStyle, marginBottom: '12px', fontSize: '15px'}}>Communication Channels <span style={{color: 'red'}}>*</span></label>
                    <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '12px' }}>Select the channels through which you agree to receive communications:</p>
                    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '16px' }}>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="whatsapp" checked={formData.whatsapp} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#059669' }} />
                        WhatsApp
                      </label>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="email_channel" checked={formData.email_channel} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#059669' }} />
                        Email
                      </label>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="sms" checked={formData.sms} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#059669' }} />
                        SMS
                      </label>
                    </div>
                  </div>

                  <div style={{ marginBottom: '24px', padding: '20px', backgroundColor: '#f9fafb', borderRadius: '10px', border: '1px solid #e5e7eb' }}>
                    <label style={{...labelStyle, marginBottom: '12px', fontSize: '15px'}}>Message Categories <span style={{color: 'red'}}>*</span></label>
                    <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '12px' }}>Select the types of messages you wish to receive:</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="transactional" checked={formData.transactional} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#059669' }} />
                        <span><strong>Transactional</strong> — Invoices, receipts, payment confirmations, billing alerts</span>
                      </label>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="promotional" checked={formData.promotional} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#059669' }} />
                        <span><strong>Promotional</strong> — Offers, discounts, campaigns</span>
                      </label>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="updates" checked={formData.updates} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#059669' }} />
                        <span><strong>Updates</strong> — Product updates, feature announcements, newsletters</span>
                      </label>
                    </div>
                  </div>

                  <div style={{ marginBottom: '30px', padding: '16px', backgroundColor: '#ecfdf5', borderRadius: '10px', border: '1px solid #a7f3d0' }}>
                    <label style={{...checkboxLabelStyle, alignItems: 'flex-start'}}>
                      <input type="checkbox" name="agreePrivacy" checked={formData.agreePrivacy} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#059669', marginTop: '3px' }} />
                      <span style={{ fontSize: '13px' }}>
                        I agree to the <a href="/privacy-policy" target="_blank" style={{ color: '#059669' }}>Privacy Policy</a> and <a href="/terms-of-use" target="_blank" style={{ color: '#059669' }}>Terms of Service</a>.
                        I understand that I can withdraw my consent at any time by visiting the <a href="/opt-out" style={{ color: '#059669' }}>Opt-Out page</a> or
                        by replying STOP to any WhatsApp message.
                        <span style={{color: 'red'}}> *</span>
                      </span>
                    </label>
                  </div>

                  <button
                    type="submit"
                    style={{
                      width: '100%',
                      padding: '14px',
                      backgroundColor: '#059669',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'background-color 0.2s',
                    }}
                  >
                    Submit Consent
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </section>

      <footer id="footer" className="footer-area pt-120">
        <div className="container">
          <div className="subscribe-area wow fadeIn" data-wow-duration="1s" data-wow-delay="0.5s">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <div className="subscribe-content mt-45">
                  <h2 className="subscribe-title">Stay Connected <span>subscribe to our communication channels</span></h2>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mt-45" style={{ textAlign: 'right' }}>
                  <a href="/opt-in" style={{ textDecoration: 'none', padding: '12px 36px', borderRadius: '30px', backgroundColor: '#059669', color: '#fff', fontSize: '16px', fontWeight: 600, display: 'inline-block' }}>Subscribe Now</a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-widget pb-100">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-8">
                <div className="footer-about mt-50 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                  <a className="logo" href="javascript:void(0)">
                    <img src={Img0} alt="Wareozo" style={{ width: 80 }} />
                    <img src={Img1} alt="Wareozo" />
                  </a>
                  <p className="text">Simplify invoicing, automate accounting, and boost business growth with smart, secure, and efficient wareozo billing software.</p>
                  <ul className="social">
                    <li><a href="javascript:void(0)"><i className="lni lni-facebook-filled"> </i></a></li>
                    <li><a href="javascript:void(0)"><i className="lni lni-twitter-filled"> </i></a></li>
                    <li><a href="javascript:void(0)"><i className="lni lni-instagram-filled"> </i></a></li>
                    <li><a href="javascript:void(0)"><i className="lni lni-linkedin-original"> </i></a></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5 col-md-7 col-sm-12">
                <div className="footer-link d-flex mt-50 justify-content-sm-between">
                  <div className="link-wrapper wow fadeIn" data-wow-duration="1s" data-wow-delay="0.4s">
                    <div className="footer-title"><h4 className="title">Quick Link</h4></div>
                    <ul className="link">
                      <li><a href="/privacy-policy">Privacy Policy</a></li>
                      <li><a href="/terms-of-use">Terms of Service</a></li>
                      <li><a href="/signin#pricing">Pricing</a></li>
                      <li><a href="/signin#faq">FAQ</a></li>
                      <li><a href="/opt-out">Unsubscribe</a></li>
                    </ul>
                  </div>
                  <div className="link-wrapper wow fadeIn" data-wow-duration="1s" data-wow-delay="0.6s">
                    <div className="footer-title"><h4 className="title">Resources</h4></div>
                    <ul className="link">
                      <li><a href="/signin#home">Home</a></li>
                      <li><a href="/signin#features">Features</a></li>
                      <li><a href="/signin#about">About</a></li>
                      <li><a href="/signin#why">Why</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12">
                <div className="footer-contact mt-50 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.8s">
                  <div className="footer-title"><h4 className="title">Contact Us</h4></div>
                  <ul className="contact">
                    <li>support@wareozo.com</li>
                    <li>www.wareozo.com</li>
                    <li>121, Sai Nagar, Near HBL Tower, <br /> Nagpur, Maharashtra - 441108</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-copyright">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright d-sm-flex justify-content-between">
                  <div className="copyright-content">
                    <p className="text">Designed and Developed by <a href="javascript:void(0)" rel="nofollow"> &nbsp; Wareozo</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="particles-2"></div>
      </footer>

      <a href="#" className="back-to-top"> <i className="lni lni-chevron-up"> </i> </a>

      <Modal open={open} onClose={(_event: any, reason: any) => {
        if (reason && reason == "backdropClick" && "escapeKeyDown")
          setOpen(false);
      }}>
        <div className='centerme'>
          <div className={`${isMobile ? 'maindiv2' : 'maindiv'}`}>
            <div style={{ width: isMobile ? '100%' : '50%' }}>
              {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType} /> : <ForgotPassword setType={setType} />}
            </div>
            {!isMobile && <div style={{ width: '50%' }}><img src={BgImg2} /></div>}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default OptInForm;
